module.exports = __webpack_public_path__ + "img/card-btn-2.f57902a9.png";